module.exports = __webpack_public_path__ + "static/media/dotted-line-mesh-element.8fab754e.svg";